import { createSlice, current } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios, endpoint } from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  posts: [],
  parallelByKelas: [],
  index: 0,
};

const slice = createSlice({
  name: 'paralel',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET KELAS
    getParallelSuccess(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    // GET KELAS by JENJANG
    getParallelByKelasSuccess(state, action) {
      const stateParallel = current(state);
      let dataParallel = [];
      // stateParallel.posts.map((val, i) => {
      //     if (val.kelas_id == action.payload.kelas_id)
      //         dataParallel.push(val)
      // })
      dataParallel = stateParallel.posts.filter(
        (item) => item.kelas_id === action.payload.kelas_id,
      );

      state.isLoading = false;
      state.parallelByKelas = dataParallel;
    },

    // RESET STATE
    reset() {
      return initialState;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { getParallelSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getAllParallel() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(endpoint.parallel.option);
      dispatch(slice.actions.getParallelSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getParallelByKelas(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.getParallelByKelasSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setAllParallel() {
  return async (dispatch) => {
    dispatch(slice.actions.reset);
  };
}
